import {inject} from "@angular/core";
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {AuthenticationService, EventService} from "@services";
import {EventItem} from "@model";

export const FavoriteEventRacesResolver: ResolveFn<Observable<EventItem[]> | EventItem[]> =
  (route: ActivatedRouteSnapshot,
   state: RouterStateSnapshot,
   authenticationService: AuthenticationService = inject(AuthenticationService),
   eventRaceService: EventService = inject(EventService)): Observable<EventItem[]> | EventItem[] => {
    if (authenticationService.isAuthenticated()) {
      return eventRaceService.fetchUserFavoritesEvent();
    } else {
      return [];
    }
  }
